export default __webpack_public_path__ + "static/media/IQ.ba4d1848.svg";